import type { DocListItem } from '@/models/interfaces'
import { QUESTIONNAIRE_BOOKS } from '@/models/onboarding.books'
import type { SampleGuideChoice20710 } from '@/models/onboarding.types'

export const SEARCH_FETCH_LIMIT = 24
export const SEARCH_DEBOUNCE_MS = 300

/** Authors for the first books in QUESTIONNAIRE_BOOKS, in that order. */
const INITIAL_BOOK_AUTHORS = [
  'James Clear',
  'Neil Dagger',
  'Mel Robbins',
  'Matt Abrahams',
  'Robert Greene',
  'Stephen R. Covey',
  'Cal Newport',
  'Daniel Kahneman',
  'Dale Carnegie',
  'Mark Manson',
  'Morgan Housel',
  'Robert Greene',
  'Loretta Graziano Breuning',
  'Michael Gervais',
  'Chris Voss',
  'Daniel E. Lieberman',
] as const

function slugFromCover(cover: string): string {
  const file = cover.slice(cover.lastIndexOf('/') + 1)
  return file.slice(0, -'-cover.png'.length)
}

/**
 * Popular guides shown before the user searches. Titles, covers, and slugs
 * come from the first books in the questionnaire catalog.
 */
export const INITIAL_BOOKS: readonly SampleGuideChoice20710[] =
  QUESTIONNAIRE_BOOKS.slice(0, INITIAL_BOOK_AUTHORS.length).map(
    (book, index) => ({
      title: book.title,
      url_slug: slugFromCover(book.cover),
      cover_image: book.cover,
      author: INITIAL_BOOK_AUTHORS[index],
    }),
  )

export function sampleGuideFromDoc(doc: DocListItem): SampleGuideChoice20710 {
  return {
    title: doc.title,
    url_slug: doc.url_slug,
    cover_image: doc.cover_image,
    author: doc.author,
  }
}
